// Hides the floating Rewards / Live Talk widgets (base.css) while [data-floating-widget-guard] UI sits in the bottom band they cover.
const WIDGET_BAND_MARGIN = '-84% 0px 0px 0px';

document.addEventListener('DOMContentLoaded', () => {
  const guarded = document.querySelectorAll('[data-floating-widget-guard]');
  if (!guarded.length) return;

  const inBand = new Set();
  const observer = new IntersectionObserver(
    (entries) => {
      for (const { target, isIntersecting } of entries) {
        if (isIntersecting) inBand.add(target);
        else inBand.delete(target);
      }
      document.body.toggleAttribute('data-widget-guard', inBand.size > 0);
    },
    { rootMargin: WIDGET_BAND_MARGIN },
  );

  for (const element of guarded) observer.observe(element);
});
